/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.restricted-toolbar[_ngcontent-%COMP%]{background-color:#fff;padding:15px 0 35px 10px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL3Jlc3RyaWN0ZWQtdG9vbGJhci9yZXN0cmljdGVkLXRvb2xiYXIuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9ydW5uZXIvd29yay9zbGlwcmVzaXN0YW50L3NsaXByZXNpc3RhbnQvY2xpZW50L3NyYy9hcHAvcmVzdHJpY3RlZC10b29sYmFyL3Jlc3RyaWN0ZWQtdG9vbGJhci5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/$$_gendir/app/restricted-toolbar/restricted-toolbar.component.scss.shim.ngstyle.ts